(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("leaflet"), require("leaflet.locatecontrol"), require("vue2-leaflet"));
	else if(typeof define === 'function' && define.amd)
		define(["leaflet", "leaflet.locatecontrol", "vue2-leaflet"], factory);
	else if(typeof exports === 'object')
		exports["Vue2LeafletLocatecontrol"] = factory(require("leaflet"), require("leaflet.locatecontrol"), require("vue2-leaflet"));
	else
		root["Vue2LeafletLocatecontrol"] = factory(root["leaflet"], root["leaflet.locatecontrol"], root["vue2-leaflet"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition